import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";
import { DISTRIBUTION_CENTER_SERVICE } from "../EndPoints";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllDistributionCenter = createAsyncThunk(
    'distributionCenterSection/getAllDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(DISTRIBUTION_CENTER_SERVICE.getAllDistributionCenter, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create department
export const CreateDistributionCenter = createAsyncThunk(
    'distributionCenterSection/createDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(DISTRIBUTION_CENTER_SERVICE.createDistributionCenter, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const UpdateDistributionCenter = createAsyncThunk(
    'distributionCenterSection/updateDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DISTRIBUTION_CENTER_SERVICE.updateDistributionCenter, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const DeleteDistributionCenter = createAsyncThunk(
    'distributionCenterSection/deleteDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`${DISTRIBUTION_CENTER_SERVICE.deleteDistributionCenter}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ListOfUsersDistributionCenter = createAsyncThunk(
    'distributionCenterSection/listOfUsersDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`${DISTRIBUTION_CENTER_SERVICE.listOfUsersDistributionCenter}${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// list of all user not belong to department
export const GetAllNonDistributionCenterUser = createAsyncThunk(
    'distributionCenterSection/getAllNonDistributionCenterUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${DISTRIBUTION_CENTER_SERVICE.getAllNonDistributionCenterUser}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
